import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { makePointer } from '../../../api/_utils'
import { UserButtonSelectorProps } from '../_props'
import UserFormField from '../UserFormField'
import { computeOptions } from '../utils/computeData'
import { useGetIdsReferencesHcspositionrefs } from '@toktokdoctech/tokapi-client'

const UserFunction = () => {
    const { control, watch, setValue } = useFormContext()
    const selfMode = watch('selfMode')
    const { data } = useGetIdsReferencesHcspositionrefs()

    const handleChange = (position: string) => {
        const selectedPosition = data?.find((el) => el?.name === position)

        const positionId = selectedPosition?.id ?? ''
        const positionName = selectedPosition?.name ?? ''

        const positionPointer = makePointer('HcsPosition', positionId)
        setValue('positionPointer', positionPointer)
        setValue('positionName', positionName)
        setValue('positionId', positionId)
    }

    const hcsPositions = React.useMemo(() => {
        if (data) {
            const positions: UserButtonSelectorProps[] = computeOptions(data)
            return positions
        }
        return []
    }, [data])

    const tooltipTitle =
        'Champ renseigné par votre administrateur lors de la création de votre compte. Si vous souhaitez modifier cette information, veuillez le contacter directement'

    return (
        <Controller
            control={control}
            name="positionName"
            render={({ field, fieldState: { error, isTouched } }) => (
                <UserFormField
                    variant="select"
                    type="default"
                    label="Fonction dans l'établissement"
                    name={field.name}
                    status={{
                        error,
                        valid: isTouched && Boolean(field.value),
                    }}
                    placeholder="Fonction dans l'établissement"
                    value={field.value || undefined}
                    locked={selfMode}
                    tooltipTitle={selfMode ? tooltipTitle : undefined}
                    onChange={(e) => {
                        handleChange(e)
                    }}
                    options={hcsPositions}
                    dataCyScope="UserField"
                />
            )}
        />
    )
}

export default UserFunction
